<template>
  <div>
    <v-row>
      <v-col>
        <h2>Questions</h2>
      </v-col>
      <v-spacer />
      <v-col class="text-right">
        <print-questions
          :filters="printFilters"
          :context-names="printContextNames"
          title="Questions"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="6" md="3">
        <v-autocomplete
          v-model="selectedModuleId"
          :items="modules"
          item-text="name"
          item-value="id"
          label="Module"
          clearable
          dense
          outlined
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-autocomplete
          v-model="selectedComponentId"
          :items="componentOptions"
          item-text="name"
          item-value="id"
          label="Component"
          clearable
          dense
          outlined
          hide-details
          :disabled="!selectedModuleId"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-autocomplete
          v-model="selectedTopicId"
          :items="topicOptions"
          item-text="name"
          item-value="id"
          label="Topic"
          clearable
          dense
          outlined
          hide-details
          :disabled="!selectedComponentId"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-autocomplete
          v-model="selectedProcedureId"
          :items="procedureOptions"
          item-text="name"
          item-value="id"
          label="Procedure"
          clearable
          dense
          outlined
          hide-details
          :disabled="!selectedComponentId"
        />
      </v-col>
      <v-col cols="12" sm="6" md="1" class="d-flex align-center">
        <v-btn
          v-if="hasFilters"
          text
          small
          color="primary"
          @click="clearFilters"
        >
          Clear
        </v-btn>
      </v-col>
    </v-row>

    <questions-table
      :show-relations="true"
      :show-add-button="false"
      :media-options="mediaOptions"
      :useEditModel="false"
      :moduleId="selectedModuleId"
      :componentId="selectedComponentId"
      :topicId="selectedTopicId"
      :procedureId="selectedProcedureId"
      @row:view="view"
    />
  </div>
</template>

<script>
import contentPageMixin from '@/components/mixins/content-page'
import QuestionsTable from '@/components/knowledgeCheck/questions-table.vue'
import PrintQuestions from '@/components/knowledgeCheck/print-questions.vue'
import { lookups } from '@/services/api'

export default {
  mixins: [contentPageMixin],
  components: {
    QuestionsTable,
    PrintQuestions
  },
  data() {
    return {
      modules: [],
      selectedModuleId: null,
      selectedComponentId: null,
      selectedTopicId: null,
      selectedProcedureId: null
    }
  },
  computed: {
    localCrumbs() {
      const items = [
        {
          text: 'Questions',
          to: { name: 'questions-create', params: {} }
        }
      ]

      return items
    },
    mediaOptions() {
      return {
        showUpload: true,
        title: 'Media Selector',
        moduleId: this.selectedModuleId,
        componentId: this.selectedComponentId,
        procedureId: this.selectedProcedureId,
        topicId: this.selectedTopicId
      }
    },
    selectedModule() {
      if (!this.selectedModuleId) return null
      return this.modules.find((m) => m.id === this.selectedModuleId)
    },
    componentOptions() {
      if (!this.selectedModule) return []
      return this.selectedModule.components || []
    },
    selectedComponent() {
      if (!this.selectedComponentId) return null
      return this.componentOptions.find(
        (c) => c.id === this.selectedComponentId
      )
    },
    topicOptions() {
      if (!this.selectedComponent) return []
      return this.selectedComponent.topics || []
    },
    procedureOptions() {
      if (!this.selectedComponent) return []
      return this.selectedComponent.procedures || []
    },
    hasFilters() {
      return (
        this.selectedModuleId ||
        this.selectedComponentId ||
        this.selectedTopicId ||
        this.selectedProcedureId
      )
    },
    selectedTopic() {
      if (!this.selectedTopicId) return null
      return this.topicOptions.find((t) => t.id === this.selectedTopicId)
    },
    selectedProcedure() {
      if (!this.selectedProcedureId) return null
      return this.procedureOptions.find(
        (p) => p.id === this.selectedProcedureId
      )
    },
    printFilters() {
      return {
        moduleId: this.selectedModuleId,
        componentId: this.selectedComponentId,
        topicId: this.selectedTopicId,
        procedureId: this.selectedProcedureId
      }
    },
    printContextNames() {
      return {
        module: this.selectedModule && this.selectedModule.name,
        component: this.selectedComponent && this.selectedComponent.name,
        topic: this.selectedTopic && this.selectedTopic.name,
        procedure: this.selectedProcedure && this.selectedProcedure.name
      }
    }
  },
  watch: {
    selectedModuleId() {
      this.selectedComponentId = null
    },
    selectedComponentId() {
      this.selectedTopicId = null
      this.selectedProcedureId = null
    }
  },
  async mounted() {
    this.modules = await lookups.modules()
  },
  methods: {
    view(item) {
      this.$router.push({
        name: 'question-detail',
        params: { questionId: item.id }
      })
    },
    clearFilters() {
      this.selectedModuleId = null
    }
  }
}
</script>

<style scoped></style>
